import { FC, useMemo } from "react";
import { Auth } from "../../../../store/auth/reducer";
import { useFetchable } from "../../../../store/common/fetchable";
import { isFetchableSuccess } from "../../../../store/common/fetchable/helpers";
import { Verification } from "../../../../store/verification/reducer";

/**
 * This hook will return whether the user can edit KYCs: either they are admin or merchant and have the
 * outsourceComplianceReviews set.
 * @returns If the current user can edit KYCs
 */
export function useCanEditKyc() {
  const currentMerchant = useFetchable(Verification.currentMerchantConfig);
  const currentUser = useFetchable(Auth.login);
  return useMemo(
    () =>
      isFetchableSuccess(currentUser) &&
      (currentUser.data.accessToken.roles.includes("ROLE_ADMIN") ||
        (currentUser.data.accessToken.roles.includes("ROLE_MERCHANT") &&
          isFetchableSuccess(currentMerchant) &&
          currentMerchant.data.outsourceComplianceReviews)),
    [currentUser, currentMerchant]
  );
}

export const CanEditKyc: FC<{}> = ({ children }) => {
  const canEdit = useCanEditKyc();
  return canEdit ? <>{children}</> : null;
};
